import { Box, Grid, Paper, Tab, Tabs, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const MRINav = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [value, setValue] = useState("/mri");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const valid = ["/mri", "/mri/tests", "/mri/patient-records"];
    if (valid.includes(location.pathname)) setValue(location.pathname);
    else setValue("/mri");
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={(e, v) => {
              setValue(v);
              navigate(v);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" },
            }}
          >
            <Tab
              style={{ ...tabStyle, backgroundColor: value === "/mri" ? theme.palette.primary.main : "white", color: value === "/mri" ? "white" : "black" }}
              label={t("mri.dashboard", "Dashboard")}
              value="/mri"
              component={NavLink}
              to="/mri"
            />
            <Tab
              style={{ ...tabStyle, backgroundColor: value === "/mri/tests" ? theme.palette.primary.main : "white", color: value === "/mri/tests" ? "white" : "black" }}
              label={t("mri.mriType", "MRI Type")}
              value="/mri/tests"
              component={NavLink}
              to="/mri/tests"
            />
            <Tab
              style={{ ...tabStyle, backgroundColor: value === "/mri/patient-records" ? theme.palette.primary.main : "white", color: value === "/mri/patient-records" ? "white" : "black" }}
              label={t("mri.testResult", "Test Result")}
              value="/mri/patient-records"
              component={NavLink}
              to="/mri/patient-records"
            />
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default MRINav;


